<template lang="pug">
    v-card.px-3
        modal-supervisor(
            :available="true" 
            title="BÚSQUEDA DE DOCUMENTOS"  
            @check-key="auth()"
            confirmMessage="Autorizar búsqueda de documento"
            style="opacity: 0; position: fixed; top:0px; left:0px; margin-left: -1000px;"
            @closed="$router.push('/')"
            )
        CustomerSearchModal(
            v-model="activeCustomerSearchModal"
            @customer:set="setCustomer"
            )
        div(v-if="authorized")
            v-layout.pt-3(wrap)
                v-flex.xs12.sm3.title.d-flex.align-center BUSCAR
                v-flex.xs12.sm3
                    v-radio-group(
                        row
                        v-model="searchType"
                        :disabled="isLoading"
                        )
                        v-radio(label="Boleta" :value="1")
                        v-radio(label="Factura" :value="2")
                        v-radio(label="Nota de Crédito" :value="3")
                v-flex.xs12.sm4
                    v-text-field(
                        label="N° Documento"
                        mask="############"
                        outline
                        :disabled="isLoading"
                        @keydown.enter="handleSearch()"
                        v-model="searchNumber"
                        )
                v-flex.xs12.my-3
                    v-divider

                v-flex.xs12.title DOCUMENTOS EMITIDOS
                v-flex.xs6.pt-3.px3
                    label Desde
                    DateField(
                        :fieldProps="{label: 'Desde'}"
                        outline
                        v-model="emissionDateMin")
                v-flex.xs6.pt-3.px-3
                    label Hasta
                    DateField(
                        :fieldProps="{label: 'Hasta'}"
                        outline
                        v-model="emissionDateMax")
                v-flex.xs8
                    label Cliente
                    v-text-field(
                        outline
                        :disabled="isLoading || activeType === 1"
                        readonly
                        :placeholder="customerFieldPlaceholder"
                        :value="customerFieldText"
                        )
                v-flex.xs2.pt-3
                    v-btn.primary(
                        :disabled="isLoading || activeType === 1"
                        block
                        style="height:54px;"
                        @click="activeCustomerSearchModal = true"
                        ) SELECCIONAR
                v-flex.xs2.pt-3
                    v-btn.primary(
                        :disabled="isLoading || activeType === 1"
                        block
                        outline
                        style="height:54px;"
                        @click="clearCustomer"
                        ) LIMPIAR

                v-flex.xs12.sm4
                    v-btn.primary(
                        :outline="activeType !== 1"
                        block
                        :disabled="isLoading"
                        @click="activeType = 1"
                    ) BOLETAS ELECTRÓNICAS
                v-flex.xs12.sm4
                    v-btn.primary(
                        :outline="activeType !== 2"
                        block
                        :disabled="isLoading"
                        @click="activeType = 2"
                    )  FACTURAS ELECTRÓNICAS
                v-flex.xs12.sm4
                    v-btn.primary(
                        :outline="activeType !== 3"
                        block
                        :disabled="isLoading"
                        @click="activeType = 3"
                    ) NOTAS DE CRÉDITO ELECTRÓNICAS
            SimpleModelDataTable(
                :model="activeModel",
                :headers="activeHeaders"
                ref="table"
                @isLoading="isLoading = $event"
                @error="errorResponseSnackbar"
                )
                template(slot="Acciones" slot-scope="{item}")
                    v-btn(
                        icon
                        :disabled="isLoading"
                        @click="launchDetailModal(item)"
                        )
                        v-icon.blue--text visibility
                    v-btn(
                        icon
                        :disabled="isLoading"
                        @click="handlePrint(item)"
                        )
                        v-icon.green--text print
            v-dialog(v-model="showDetailModal" :persistent="isLoading")
                v-toolbar.primary(dark)
                    .d-flex(style="width: 100%; justify-content: space-between;")
                        span.title {{detailTitle}}
                        v-btn.success(
                            style="max-width: 120px;"
                            @click="handlePrint(activeDetail)"
                            :disabled="isLoading"
                            ) IMPRIMIR
                v-card.pa-3
                    v-layout.mx-3.mb-4(wrap)
                        v-flex.xs4.py-2.px-1(
                            v-if="activeHeaders && activeDetail"
                            v-for="header in activeDetailTopDataIterator"
                            :key="header.text")
                            template(v-if="activeDetail[header.value]")
                                b {{header.text}}: 
                                span {{activeDetail[header.value]}}
                    b.mt-4.ml-4.title Detalle:
                    v-data-table(
                        :headers="detailHeaders"
                        :items="activeDetailItems"
                        hide-actions
                        )
                        template(slot="items" slot-scope="props")
                            td {{props.item.wh_product.id}}
                            td {{props.item.wh_product.name}}
                            td {{parseFloat(props.item.quantity)}}
                            td {{getItemPrice(props.item) | mixFormatCurrency}}
                            td {{getItemDiscounts(props.item)}}
                            td {{getItemTotal(props.item) | mixFormatCurrency}}
                    b.mt-4.ml-4.title(
                        v-if="detailType !== 3 && activeDetailPayments"
                        ) Pagos:
                    v-data-table(
                        :headers="paymentHeaders"
                        :items="activeDetailPayments"
                        v-if="detailType !== 3 && activeDetailPayments"
                        hide-actions
                        )
                        template(slot="items" slot-scope="props")
                            td {{props.item.type}}
                            td {{props.item.amount}}
                            td
                                div.pa-3(v-for="detail in props.item.detail" :key="detail.label")
                                    b {{detail.label}}    
                                    span {{detail.value}}
                            
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSupervisor from '@/components/SupervisorUniqueKey/Modal'
import cashDeskOpenLeaveGuard from '@/mixins/cashDeskOpenLeaveGuard'
import cashDeskMustCloseCashGuard from '@/mixins/cashDeskMustCloseCashGuard'
import SlSaleInvoice from '@/models/Sale/SlSaleInvoice'
import SlSaleTicket from '@/models/Sale/SlSaleTicket'
import CurrencyUtils from '../../mixins/CurrencyUtils'
import SlSaleCreditNote from '../../models/Sale/SlSaleCreditNote'
import {
    ticketHeaders,
    creditNoteHeaders,
    invoiceHeaders,
    detailHeaders,
    paymentHeaders,
} from './headers'
import { creditNoteIncludes, invoiceIncludes, ticketIncludes } from './includes'
import SimpleModelDataTable from '../../components/SimpleModelDataTable/SimpleModelDataTable'
import DateField from '../../components/reusable_components/next/DateField'
import {
    dateToYYYYMMDD,
    addMonthsToDate,
    numberFormatter,
} from '../../services/JSUtils'
import CustomerSearchModal from '../../components/CustomerSearch/CustomerSearch'

export default {
    name: 'dte-list',
    props: {},
    data: () => ({
        authorized: false,
        activeType: 1, // 1 - Boleta, 2 - Factura, 3 - NC
        isLoading: false,
        showDetailModal: false,
        activeDetail: null,
        searchType: 1,
        detailType: 1,
        searchNumber: '',
        emissionDateMin: dateToYYYYMMDD(addMonthsToDate(new Date(), -1)),
        emissionDateMax: dateToYYYYMMDD(new Date()),
        paymentHeaders,
        activeCustomerSearchModal: false,
        activeCustomer: null,
    }),
    computed: {
        activeModel() {
            const mdl = [
                new SlSaleTicket()
                    .include(...ticketIncludes)
                    .append('cash_change', 'rounding_law')
                    .orderBy('-updated_at'),
                new SlSaleInvoice()
                    .include(...invoiceIncludes)
                    .append('cash_change', 'rounding_law'),
                new SlSaleCreditNote()
                    .include(...creditNoteIncludes)
                    .orderBy('-updated_at'),
            ][this.activeType - 1]
            if (this.emissionDateMin)
                mdl.where('emission_date_min', this.emissionDateMin)
            if (this.emissionDateMax)
                mdl.where('emission_date_max', this.emissionDateMax)
            if (this.customerFilterId)
                mdl.where('sl_customer_id', this.customerFilterId)
            return mdl
        },
        activeSearchModel() {
            return [
                new SlSaleTicket()
                    .include(
                        ...ticketIncludes,
                        'sl_detail_sale_tickets.wh_product'
                    )
                    .append('cash_change', 'rounding_law', 'payments'),
                new SlSaleInvoice()
                    .include(
                        ...invoiceIncludes,
                        'sl_detail_sale_invoices.wh_product'
                    )
                    .append('cash_change', 'rounding_law', 'payments'),
                new SlSaleCreditNote().include(
                    ...creditNoteIncludes,
                    'sl_detail_sale_credit_notes.wh_product'
                ),
            ][this.searchType - 1]
        },
        activeHeaders() {
            return [ticketHeaders, invoiceHeaders, creditNoteHeaders][
                this.activeType - 1
            ]
        },
        detailHeaders() {
            return detailHeaders
        },
        detailTitle() {
            return this.activeDetail
                ? ['Boleta', 'Factura', 'Nota de Crédito'][
                      this.detailType - 1
                  ] + ` N°${this.activeDetail.number}`
                : ''
        },
        activeDetailTopDataIterator() {
            // if (!this.activeHeaders) return []
            let arr = this.activeHeaders.filter(h => h.value !== 'slot')
            if (this.detailType !== 3)
                arr.splice(
                    this.activeHeaders.length - 1,
                    0,
                    {
                        text: 'Ley de Redondeo',
                        value: 'formattedRoundingLaw',
                    },
                    { text: 'Vuelto', value: 'formattedCashChange' }
                )
            return arr
        },
        activeDetailItems() {
            return this.activeDetail
                ? this.activeDetail[
                      [
                          'sl_detail_sale_tickets',
                          'sl_detail_sale_invoices',
                          'sl_detail_sale_credit_notes',
                      ][this.detailType - 1]
                  ]
                : []
        },
        activeDetailPayments() {
            if (this.detailType === 3 || !this.activeDetail) return null
            return this.activeDetail.payments.map(payment => {
                let formattedPayment = {
                    type: payment.pos_sale_payment_type,
                    amount:
                        payment.pos_sale_payment_type_id === 1
                            ? parseInt(payment.amount) +
                              parseInt(this.activeDetail.cash_change)
                            : parseInt(payment.amount),
                }
                const detailTypes = [
                    { label: 'N°Operación: ', propName: 'voucher_number' },
                    { label: 'N°Cuotas: ', propName: 'shares_number' },
                    // { text: '', propName: 'terminal_id' },
                    // { text: '', propName: 'authorization_code' },
                    { label: 'N°Transferencia: ', propName: 'transfer_number' },
                    // { text: '', propName: 'sl_sale_credit_note_id' },
                    {
                        label: 'N°Nota de Crédito: ',
                        propName: 'sl_sale_credit_note_number',
                    },
                    // { text: '', propName: 'pos_customer_credit_option_id' },
                    {
                        label: 'Plazo: ',
                        propName: 'pos_customer_credit_option_type',
                    },
                    { label: 'Banco', propName: 'bank' },
                    { label: 'Serie: ', propName: 'serial_number' },
                    { label: 'N°Cuenta: ', propName: 'account_number' },
                    { label: 'Plaza: ', propName: 'plaza' },
                    { label: 'Fecha Cobro: ', propName: 'charge_date' },
                    // { text: '', value: 'type' },
                ]
                formattedPayment.detail = detailTypes
                    .map(
                        type =>
                            payment[type.propName]
                                ? {
                                      label: type.label,
                                      value: payment[type.propName],
                                  }
                                : null
                    )
                    .filter(d => !!d)
                formattedPayment.amount =
                    '$ ' + numberFormatter(parseInt(formattedPayment.amount))
                return formattedPayment
            })
        },
        ...mapState('SessionModule', ['companyData', 'htmlPrint']),
        customerFieldPlaceholder() {
            return this.activeType === 1
                ? 'Filtro habilitado sólo para Facturas o Notas de Crédito'
                : 'Filtrar por Cliente'
        },
        customerFieldText() {
            if (this.activeCustomer) return this.activeCustomer.alias_name
            return ''
        },
        customerFilterId() {
            return this.activeCustomer ? this.activeCustomer.id : null
        },
    },
    methods: {
        auth: async function() {
            let response = await this.authorize()
            if (response.is_authorized) {
                this.authorized = true
            } else {
                this.$router.push('/')
            }
        },
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
            setUniqueKey: 'setUniqueKey',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        ...mapActions('CashDeskModule', ['reprintDTE']),
        errorResponseSnackbar(e) {
            this.errorSnackbar(
                e && e.response && e.response.data && e.response.data.error
                    ? e.response.data.error
                    : e &&
                      e.response &&
                      e.response.data &&
                      e.response.data.message
                        ? e.response.data.message
                        : e || 'Ha ocurrido un error'
            )
        },
        errorSnackbar(message) {
            this.initSnackbar(this.fillSnack('error', 'Error', message))
        },
        successSnackbar(message) {
            this.initSnackbar(this.fillSnack('success', 'Éxito', message))
        },
        getItemPrice(item) {
            if (item.price) return item.price
            return Math.round(item.net_price * 1.19)
        },
        getItemDiscounts(item) {
            if (parseInt(item.discount_or_charge_percentage))
                return parseInt(item.discount_or_charge_percentage) + ' %'
            if (parseInt(item.discount_or_charge_value))
                return '$ ' + parseInt(item.discount_or_charge_value)
            return '-'
        },
        getItemTotal(item) {
            let tot = this.getItemPrice(item) * item.quantity
            if (parseInt(item.discount_or_charge_percentage))
                return (
                    tot *
                    ((100 - parseInt(item.discount_or_charge_percentage)) / 100)
                )
            if (parseInt(item.discount_or_charge_value))
                return tot + parseInt(item.discount_or_charge_value)
            return tot
        },
        launchDetailModal(item) {
            let mdl = new [SlSaleTicket, SlSaleInvoice, SlSaleCreditNote][
                this.activeType - 1
            ]()
            this.isLoading = true
            mdl.include(
                [
                    'sl_detail_sale_tickets.wh_product',
                    'sl_detail_sale_invoices.wh_product',
                    'sl_detail_sale_credit_notes.wh_product',
                ][this.activeType - 1]
            )
            this.activeDetail = this.activeType
            if (this.activeDetail !== 3) mdl.append('payments')
            mdl.find(item.id)
                .then(r => {
                    this.activeDetail = Object.assign(item, r)
                    this.showDetailModal = true
                })
                .catch(this.errorResponseSnackbar)
                .finally(() => (this.isLoading = false))
        },
        async handlePrint(item) {
            this.isLoading = true
            if (
                (this.showDetailModal && this.detailType === 1) ||
                (!this.showDetailModal && this.activeType === 1)
            ) {
                return new SlSaleTicket()
                    .printTicketSaleReceiptByNumber(
                        item.number,
                        this.companyData,
                        this.htmlPrint
                    )
                    .then(() =>
                        this.successSnackbar('Boleta impresa exitosamente')
                    )
                    .catch(this.errorResponseSnackbar)
                    .finally(() => (this.isLoading = false))
            }
            if (
                (this.showDetailModal && this.detailType === 2) ||
                (!this.showDetailModal && this.activeType === 2)
            ) {
                try {
                    await this.reprintDTE(item)
                    this.successSnackbar('Factura descargada exitosamente')
                } catch (e) {
                    this.errorResponseSnackbar(e)
                }
                this.isLoading = false
                return
            }
            if (
                (this.showDetailModal && this.detailType === 3) ||
                (!this.showDetailModal && this.activeType === 3)
            ) {
                try {
                    if (item.isInvoiceCreditNote) {
                        await item.downloadPdf()
                    } else {
                        item.ticketHtmlPrint(this.companyData)
                    }
                    this.successSnackbar(
                        'Nota de Crédito descargada exitosamente'
                    )
                } catch (e) {
                    this.errorResponseSnackbar(e)
                }
                this.isLoading = false
                return
            }
        },
        handleSearch(number = this.searchNumber) {
            this.isLoading = true
            this.activeSearchModel
                .where('exact_number', number)
                .get()
                // .first()
                .then(r => {
                    if (!r.data)
                        return this.errorSnackbar(
                            'Folio consultado no existe para este tipo de documento'
                        )
                    this.detailType = this.searchType
                    this.activeDetail = r.data.find(
                        document => document.number === number
                    )
                    this.showDetailModal = true
                })
                .catch(this.errorResponseSnackbar)
                .finally(() => (this.isLoading = false))
        },
        setCustomer(customer) {
            this.activeCustomer = customer
        },
        clearCustomer() {
            this.activeCustomer = null
        },
    },
    watch: {
        showDetailModal(v) {
            if (!v) this.activeDetail = null
        },
        activeType(v) {
            this.detailType = v
            if (v === 1) this.activeCustomer = null
        },
    },
    components: {
        'modal-supervisor': ModalSupervisor,
        SimpleModelDataTable,
        DateField,
        CustomerSearchModal,
    },
    mixins: [cashDeskOpenLeaveGuard, cashDeskMustCloseCashGuard, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        this.setPermission(this.mixAuthCodePermissions.AUTHORIZE_OPEN_CASH_DESK)
        document.getElementById('supervisor-modal-button').click()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    beforeDestroy: function() {
        this.setPermission('')
        this.setUniqueKey('')
    },
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
